<template>
  <v-card>
    <v-card-title class="text-center">
      <h3>NOC Details</h3>
    </v-card-title>
    <v-card-text>
      <v-simple-table>
        <table>
          <tr>
            <th class="text-left">NOC Code - Unit Group</th>
            <td>{{ profile.unitGroup }}</td>
          </tr>
          <tr>
            <th class="text-left">Broad Occupational Category</th>
            <td>{{ profile.boc }}</td>
          </tr>
          <tr>
            <th class="text-left">NOC Code</th>
            <td>{{ profile.noc }}</td>
          </tr>
          <tr>
            <th class="text-left">ColourSpectrums NOC Analysis</th>
            <td>
              <a target="_blank" :href="downloadNoc" class="underline">Download</a>
              &nbsp;
              <a @click="compareClick()" class="underline">Compare</a>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <p>{{ profile.description }}</p>
            </td>
          </tr>
        </table>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "DetailsPanel",
  props: {
    profile: Object,
  },
  computed: {
    downloadNoc: function () {
      return "./data/NOCs/NOC " + this.profile.noc + ".pdf";
    },
  },
  methods: {
    compareClick() {
      this.$store.dispatch("clearExclusions");
      this.$store.dispatch("addExclusion", this.profile.noc);
      this.$store.dispatch("setUserProfile", this.profile);
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped>
#noc-details-container {
  padding-bottom: 0;
  box-sizing: border-box;
  margin: auto;
  /* text-align: center; */
}

.label-circle {
  fill: white;
  stroke: black;
  stroke-width: 3;
}

table * {
  font-size: 1em;
  line-height: 1.6;
}
.underline {
  text-decoration: underline;
}
</style>